import React from 'react';
import { SerializedSmartLinksList } from 'fym-common/src/db/serializersTypes';
import { TypedMemo } from '../../common/types';
import { SMLListItemBox } from '../smlListItemBox/SMLListItemBox';
import { useGetSmartLinksQuery } from '../../../redux/api/fymAPI';
import { SmartLinkFilter } from '../smlFilterTabs/types';
import { SMARTLINKS_PAGE_SIZE, smartLinksStatusOf } from './smartLinksOverviewQuery';

export type SmartLinkClicks = Map<number, { clicks: number; trend: number[] }>;

interface SmartLinksCardsProps {
  smartLinks: SerializedSmartLinksList;
  clicksBySmartLink: SmartLinkClicks;
  onSmartLinkClick: (smartLinkId: number) => void;
}

/** The cards of one request of the SmartLinks grid. */
const SmartLinksCardsComponent: React.FC<SmartLinksCardsProps> = ({
  smartLinks,
  clicksBySmartLink,
  onSmartLinkClick,
}) => (
  <>
    {smartLinks.map((smartLink) => {
      const summary = clicksBySmartLink.get(smartLink.id);
      return (
        <SMLListItemBox
          key={smartLink.id}
          smartLink={smartLink}
          onClick={onSmartLinkClick}
          clicks={summary?.clicks ?? 0}
          trend={summary?.trend}
        />
      );
    })}
  </>
);

export const SmartLinksCards = TypedMemo(SmartLinksCardsComponent);

interface SmartLinksGridPageProps {
  accountId: number;
  page: number;
  tab: SmartLinkFilter;
  search: string;
  clicksBySmartLink: SmartLinkClicks;
  onSmartLinkClick: (smartLinkId: number) => void;
}

/**
 * One "Show more" request of the grid (page 1 and up). It draws nothing while it loads; the
 * footer of the grid shows the loading line and an error.
 */
const SmartLinksGridPageComponent: React.FC<SmartLinksGridPageProps> = ({
  accountId,
  page,
  tab,
  search,
  clicksBySmartLink,
  onSmartLinkClick,
}) => {
  const trimmedSearch = search.trim();
  const { data } = useGetSmartLinksQuery({
    accountId,
    page,
    limit: SMARTLINKS_PAGE_SIZE,
    search: trimmedSearch === '' ? undefined : trimmedSearch,
    status: smartLinksStatusOf(tab),
  });
  if (!data) {
    return null;
  }
  return (
    <SmartLinksCards
      smartLinks={data.results}
      clicksBySmartLink={clicksBySmartLink}
      onSmartLinkClick={onSmartLinkClick}
    />
  );
};

export const SmartLinksGridPage = TypedMemo(SmartLinksGridPageComponent);
